/**
 * Extracted from sections/ns-exercise-demo.liquid (inline <script> at line 439).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-exercise-demo.liquid:439) ---
(function () {
document.querySelector(".shopify-section--ns-exercise-demo").querySelectorAll(".filter-button").forEach((el) => {
  el.addEventListener("click", () => {
    document.querySelector(".shopify-section--ns-exercise-demo").querySelectorAll(".filter-button").forEach((innerEl) => {
      if (innerEl != el) {
        innerEl.classList.remove("active");
      }
    })
    el.classList.add("active")
    applyExerciseFilter1(el.innerHTML);
  })
})
function applyExerciseFilter1(filterValue) {
  document.querySelector(".shopify-section--ns-exercise-demo").querySelectorAll(".ns-exercise-demo").forEach((el) => {
    if (el.getAttribute("filter-type") != filterValue) {
      el.classList.remove("active-slider");
    }
    else if (el.getAttribute("filter-type") == filterValue) {
      el.classList.add("active-slider");
    }
  })
}  
})();
